import { MultipleItemRequirementType } from "../enumerations/MultipleItemRequirementType";
import { IRequireable } from "./IRequireable";
import { Requirement } from "./Requirement";
import { RequirementItem } from "./RequirementItem";



export class MultipleItemRequirement<T extends IRequireable> extends Requirement  {
	public static readonly $type = {
		DataFieldTemplate: "MultipleItemRequirement<DataFieldTemplate>",
		ComponentTemplate: "MultipleItemRequirement<ComponentTemplate>"
	};
	public readonly $type: string = MultipleItemRequirement.$type.DataFieldTemplate;

	public requirementType!: MultipleItemRequirementType;
	public fulfillmentCount!: number;
	public items!: Array<RequirementItem<T>>;

	constructor(genericTypeName: "DataFieldTemplate" | "ComponentTemplate") {

		super();

		this.$type = `${"MultipleItemRequirement"}<${genericTypeName}>`;
	}
}
